import { render } from "./permissions-user.vue?vue&type=template&id=30292274&lang=pug"
import script from "./permissions-user.vue?vue&type=script&lang=js"
export * from "./permissions-user.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__